import * as Types from '../Constants/AllConstants';

export const PagedAccountsReducer = (state = { accounts: [] }, action) => {
  switch (action.type) {
    case Types.ACCOUNT_PAGED_REQUEST:
      return { loading: true };
    case Types.ACCOUNT_PAGED_SUCCESS:
      return {
        loading: false,
        accounts: action.payload.content,
        page: action.payload.number,
        pages: action.payload.totalPages,
      };
    case Types.ACCOUNT_PAGED_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const SubscribeEmailReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.ACCOUNT_SUBSCRIBE_EMAIL_REQUEST:
      return { loading: true };
    case Types.ACCOUNT_SUBSCRIBE_EMAIL_SUCCESS:
      return { loading: false, success: true, account: action.payload };
    case Types.ACCOUNT_SUBSCRIBE_EMAIL_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const SubscribeSMSReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.ACCOUNT_SUBSCRIBE_SMS_REQUEST:
      return { loading: true };
    case Types.ACCOUNT_SUBSCRIBE_SMS_SUCCESS:
      return { loading: false, success: true, account: action.payload };
    case Types.ACCOUNT_SUBSCRIBE_SMS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};


export const ChangeSmsOverdraftReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.ACCOUNT_CHANGE_SMS_OVERDRAFT_REQUEST:
      return { loading: true };
    case Types.ACCOUNT_CHANGE_SMS_OVERDRAFT_SUCCESS:
      return { loading: false, success: true, account: action.payload };
    case Types.ACCOUNT_CHANGE_SMS_OVERDRAFT_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const ChangeEmailOverdraftReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.ACCOUNT_CHANGE_EMAIL_OVERDRAFT_REQUEST:
      return { loading: true };
    case Types.ACCOUNT_CHANGE_EMAIL_OVERDRAFT_SUCCESS:
      return { loading: false, success: true, account: action.payload };
    case Types.ACCOUNT_CHANGE_EMAIL_OVERDRAFT_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
